module.exports = __webpack_public_path__ + "static/media/03_digginglight.ea4ba9db.jpg";